import { FolderRestriction } from '@desygner/ui-editor-menus/src/lib/views/Restrictions';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import ReactAppBuilder from 'src/utils/react-app-builder';

const StyledWrapper = styled.div`
  max-width: 300px;
`;

export class FolderRestrictionView extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  createInstance () {
    return new FolderRestrictionView({
      appId: 'react-library-folder-app',
      targetNodeSelector: '#tabRestrictions.tab .library-folder-app'
    });
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp ({ type, handleFolderSelected, workspace, selectedFolders }) {
    this.type = type;
    this.workspace = workspace;
    this.handleFolderSelected = handleFolderSelected;
    this.selectedFolders = selectedFolders;
    super.mountApp(this.App);
  }

  mapProps () {
    const credentials = useSelector(state => state.user.userInfo.credentials);
    return {
      type: this.type,
      workspace: this.workspace,
      credentials: {
        baseUrl: INKIVE.C.API_URL,
        userToken: credentials.api_key
      },
      handleFolderSelected: this.handleFolderSelected,
      selectedFolders: this.selectedFolders,
      maximumShowingNames: 1,
      labels: {
        chooseFolder: INKIVE.TranslateHelper.translate('tool.restrictions.element.common.choose_folders')
      }
    };
  }

  App = () => {
    const props = this.mapProps();

    return (
      <StyledWrapper>
        <input type={'text'} name={'library_folder'} className={'hidden'}></input>
        <FolderRestriction {...props} />
      </StyledWrapper>
    );
  };
}

export default new FolderRestrictionView({
  appId: 'react-library-folder-app',
  targetNodeSelector: '#tabRestrictions.tab .library-folder-app'
});
